import React, { useEffect, useState } from 'react';

import FundsService from '@services/Funds.service';
import Loader from '@appComponents/Loader/Loader';
import Flag from '@appComponents/Flag/Flag';
import IBankAccountConfirmation from './IBankAccountConfirmation';

import { IBankAccountProperties } from '@funds/components/WithdrawAmount/IWithdrawAmount';
import { classNames } from '@features/utils/reactFunctions';
import * as elements from '@appStyles/_elements.module.scss';

import * as style from './BankAccountConfirmationStyle.module.scss'

const BankAccountConfirmation: React.FunctionComponent<IBankAccountConfirmation> = (props) => {
  const [bankAccountData, setBankAccountData] = useState<IBankAccountProperties | undefined>(undefined);

  useEffect(() => {
    FundsService.getBankAccountFromPath(props.bank_account_path).then((res) => {
      setBankAccountData(res.data);
    });
  }, []);

  const renderRow = (label: string, value: string | JSX.Element) => {
    return (
      <div className={elements.zebraTableRow}>
        <div className={elements.zebraTableItem}>
          {label}
        </div>
        <div
          className={classNames(elements.zebraTableItem)}
        >
          {value}
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (bankAccountData) {
      return (
        <>
          <h3 className={style.bankAccountConfirmationDescription}>
            Please review the following details of bank account update request
            issued from your account:
          </h3>
          <div
            className={classNames(
              elements.zebraTableContainer,
              style.zebraTableContainer
            )}
          >
            {renderRow('BIC/SWIFT', bankAccountData.bic_swift)}
            {renderRow('Bank Name', bankAccountData.name)}
            {renderRow('Account Number', bankAccountData.account_number)}
            {renderRow('Account Beneficiary Name', bankAccountData.holder_name)}
            {renderRow(
              'Account Beneficiary Address',
              bankAccountData.holder_address.line_1
            )}
            {bankAccountData.holder_address.line_2 &&
              renderRow(
                'Account Beneficiary Address(cont.)',
                bankAccountData.holder_address.line_2
              )}
            {renderRow(
              'Account Beneficiary County',
              bankAccountData.holder_address.county
            )}
            {renderRow(
              'Account Beneficiary Postcode',
              bankAccountData.holder_address.postcode
            )}
            {renderRow(
              'Account Beneficiary Country',
              <>
                {bankAccountData.holder_address.country_name}
                &nbsp;&nbsp;
                {bankAccountData.holder_address.country_code && (
                  <Flag slug={bankAccountData.holder_address.country_code} />
                )}
              </>
            )}
          </div>
        </>
      );
    }

    return <Loader moreSpace={true}/>;
  };

  return (
    renderContent()
  );
};

export default BankAccountConfirmation;
